import { render, staticRenderFns } from "./material.vue?vue&type=template&id=2a1da28e&scoped=true"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=2a1da28e&prod&lang=less"
import style1 from "./material.vue?vue&type=style&index=1&id=2a1da28e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1da28e",
  null
  
)

export default component.exports